/**
 * Compares two semantic version strings.
 * Returns negative if v1 < v2, 0 if equal, positive if v1 > v2.
 */
export const compareVersions = (v1: string, v2: string): number => {
  const parts1 = v1.split('.').map(Number);
  const parts2 = v2.split('.').map(Number);
  const maxLength = Math.max(parts1.length, parts2.length);

  for (let i = 0; i < maxLength; i++) {
    const p1 = parts1[i] || 0;
    const p2 = parts2[i] || 0;
    if (p1 !== p2) {
      return p1 - p2;
    }
  }
  return 0;
};

/**
 * Checks if v1 is less than v2 (semantic version comparison).
 */
export const isVersionLessThan = (v1: string, v2: string): boolean => {
  return compareVersions(v1, v2) < 0;
};
